import React, { useState, useEffect, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import Service from '../../services';
import { baseUrlAdmin } from '../../store/apiConstants';
import moment from 'moment';
import './styles.scss';
import { QuestionTypeKeys, QuestionTypeKeysWithAQ } from '../questionBank/constants';
import { connect } from 'react-redux';

const PaperDownload = () => {
    const { examId } = useParams();
    const [searchParams] = useSearchParams();
    const examDate = searchParams.get('examDate');
    const questionCounterRef = useRef(0);

    const [state, setState] = useState({
        examId,
        examDate,
        exam: null,
        examType: null
    });

    const service = new Service();

    const callMathJax = () => {
        if (window && window.MathJax && window.MathJax.Hub) {
            window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        }
    };

    const minToHours = (n) => {
        var num = n;
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        if (rminutes == 0) {
            return rhours;
        } else {
            return rhours + ":" + rminutes;
        }
    };

    const renderQuestion = (q, qIndex, questions) => {
        const imageBucket = process.env.REACT_APP_IMAGES_BUCKET || 'classetimage-old';
        const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';
        switch (q.questionType) {
            case QuestionTypeKeysWithAQ.SCCT:
            case QuestionTypeKeysWithAQ.MCCT:
                return <>
                    <p className='question'><span className='qNo'>{q.qNo}.</span> {q.question}</p>
                    {
                        q.attachmentUrl && q.attachmentUrl.length > 2 && <>
                            <img src={`https://${imageBucket}.s3.${awsRegion}.amazonaws.com/` + q.attachmentUrl} className='q-attach' />
                        </>
                    }
                    <div className='sp-clearFix'></div>
                    {
                        q.options && q.options.length && q.options.map((a, oIndex) => {
                            return <div className={`option-w ${oIndex % 2 == 0 ? 'sp-clearFix' : ''}`} key={a.id}><p className='option'>{a.id}. {a.value} </p>
                                {
                                    a.imageUrl && a.imageUrl.length > 2 && <>
                                        <img src={`https://${imageBucket}.s3.${awsRegion}.amazonaws.com/` + a.imageUrl} className='o-attach' />
                                    </>
                                }
                            </div>
                        })
                    }
                </>
            case QuestionTypeKeysWithAQ.INT:
            case QuestionTypeKeysWithAQ.NUM:
            case QuestionTypeKeysWithAQ.FB:
                return <>
                    <p className='question'><span className='qNo'>{q.qNo}.</span> {q.question}</p>
                    {
                        q.attachmentUrl && q.attachmentUrl.length > 2 && <>
                            <img src={`https://${imageBucket}.s3.${awsRegion}.amazonaws.com/` + q.attachmentUrl} className='q-attach' />
                        </>
                    }
                    <div className='sp-clearFix'></div>
                    <p className='num-answer'></p>
                </>
            case QuestionTypeKeysWithAQ.PQS:
            case QuestionTypeKeysWithAQ.PQM:
                return <>
                    {/* Show passage content only once for the first question of a passage group */}
                    {(!qIndex || !(qIndex && questions[qIndex - 1]?.psgQId === q.psgQId)) && q.originalPassageQuestion && (
                        <>
                            <p className='question p-question'>{q.originalPassageQuestion.paragraph || ''}</p>
                            {
                                q.originalPassageQuestion.paragraphUrl && q.originalPassageQuestion.paragraphUrl.length > 2 && (
                                    <img src={`https://${imageBucket}.s3.${awsRegion}.amazonaws.com/` + q.originalPassageQuestion.paragraphUrl} className='q-attach' />
                                )
                            }
                        </>
                    )}
                    <div className='sp-clearFix'></div>
                    <p className='question'><span className='qNo'>{q.qNo}.</span> {q.question}</p>
                    {
                        q.attachmentUrl && q.attachmentUrl.length > 2 && <>
                            <img src={`https://${imageBucket}.s3.${awsRegion}.amazonaws.com/` + q.attachmentUrl} className='q-attach' />
                        </>
                    }
                    <div className='sp-clearFix'></div>
                    {
                        q.options && q.options.length && q.options.map((a, oIndex) => {
                            return <div className={`option-w ${oIndex % 2 == 0 ? 'sp-clearFix' : ''}`} key={a.id}><p className='option'>{a.id}. {a.value} </p>
                                {
                                    a.imageUrl && a.imageUrl.length > 2 && <>
                                        <img src={`https://${imageBucket}.s3.${awsRegion}.amazonaws.com/` + a.imageUrl} className='o-attach' />
                                    </>
                                }
                            </div>
                        })
                    }
                </>
            case QuestionTypeKeysWithAQ.VSAQ:
            case QuestionTypeKeysWithAQ.SAQ:
            case QuestionTypeKeysWithAQ.LAQ:
                return <>
                    <p className='question'><span className='qNo'>{q.qNo}.</span> {q.question}</p>
                    {
                        q.attachmentUrl && q.attachmentUrl.length > 2 && <>
                            <img src={`https://${imageBucket}.s3.${awsRegion}.amazonaws.com/` + q.attachmentUrl} className='q-attach' />
                        </>
                    }
                    <div className='sp-clearFix'></div>
                </>

            default:
                return <></>
        }
    };

    const organizeQuestionsBySection = (subject) => {
        // Create a map to store questions by section
        const sectionMap = {};

        // Initialize sections with empty questions array
        if (subject.sections && subject.sections.length > 0) {
            subject.sections.forEach(section => {
                sectionMap[section.sectionName] = {
                    ...section,
                    questions: []
                };
            });
        }

        // Assign questions to their respective sections
        if (subject.questions && subject.questions.length > 0) {
            subject.questions.forEach(question => {
                const sectionName = question.sectionName;
                if (sectionName && sectionMap[sectionName]) {
                    // For passage questions, ensure the questions array is properly populated
                    if (question.questionType === 'PSGS' || question.questionType === 'PSGM') {
                        // Make sure we have the questions array in the expected format
                        if (!Array.isArray(question.questions)) {
                            // If questions is not an array or is missing, try to recover from the exam data
                            console.warn('Passage question missing sub-questions array:', question.questionId);
                        }
                    }

                    // Add the question to its section
                    sectionMap[sectionName].questions.push(question);
                }
            });
        }

        return Object.values(sectionMap);
    };

    // Fetch exam data when component mounts or examId changes
    useEffect(() => {
        if (examId) {
            let url = `${baseUrlAdmin}/examination/exam/${examId}`;

            service.get(url, false).then((res) => {
                if (res.status && res.res && res.res.Item) {
                    setState(prevState => ({
                        ...prevState,
                        exam: res.res.Item[0],
                        examType: res.res.Item[0].examType
                    }));
                }
            }).catch(e => {
                console.error("Error fetching exam:", e);
            });
        }
    }, [examId]);

    // Call MathJax when exam data updates
    useEffect(() => {
        if (state.exam) {
            callMathJax();
        }
    }, [state.exam]);

    const { exam, examType, examDate: stateExamDate } = state;

    if (!exam) {
        return <div className="loading-container">Loading exam paper...</div>;
    }

    // Reset counter at the start of render
    questionCounterRef.current = 0;

    return (
        <div className='e-paper'>
            <header>
                <h1 className='school-title'>{exam.orgInfo?.title || 'Educational Institution'}</h1>
                <h4 className='school-address'>
                    {exam.orgInfo?.city && exam.orgInfo?.state
                        ? `${exam.orgInfo.city}, ${exam.orgInfo.state}`
                        : 'Location'}
                </h4>
            </header>

            {/* Exam Title */}
            <h2 className='e-exam-name'><span>{exam.examName}</span></h2>

            {/* Exam Details */}
            <div className='e-header'>
                <span className='e-date'>
                    <strong>Duration:</strong> {minToHours(parseInt(exam.totalTime) || 0)} Hours
                </span>
                <div className='sp-right'>
                    <p className='e-date sp-no-pm'>
                        Date: {moment(stateExamDate).format("DD-MM-YYYY")}
                    </p>
                    <p className='e-date sp-no-pm'>
                        <strong>Max. Marks:</strong> {exam.totalMarks || 0}
                    </p>
                </div>
            </div>

            {/* Exam Instructions */}
            <h5 className='exam-instruction'>Exam Instructions</h5>
            <div className='sp-ml10 e-instructions'
                dangerouslySetInnerHTML={{ __html: exam.instructions || 'No instructions provided.' }}>
            </div>

            {/* AdhocMockTest format with sections */}
            {examType === 'AdhocMockTest' && (
                <div className="exam-content">
                    {exam.subjects.map((subject, subIndex) => {
                        const sectionsWithQuestions = organizeQuestionsBySection(subject);

                        return (
                            <div key={subject.id || subIndex} className="subject-container">
                                <h3 className={`subject-name ${subIndex > 0 ? 'sp-mt40' : ''}`}>
                                    <span>{subject.subjectName}</span>
                                </h3>
                                <hr />

                                {/* Render sections within subject */}
                                {sectionsWithQuestions.map((section, sectionIndex) => (
                                    <div key={sectionIndex} className="section-container">
                                        <h4 className='section-name'>Section {sectionIndex + 1}: {section.sectionName}</h4>

                                        {/* Section instructions if available */}
                                        {section.sectionInstruction && (
                                            <div className="section-instruction-container">
                                                <h6 className='section-instruction-header'>Section Instructions:</h6>
                                                <div className='section-instructions'>
                                                    {section.sectionInstruction}
                                                </div>
                                            </div>
                                        )}

                                        <div className='paper-download'>
                                            {section.questions.map((q, qIndex) => {
                                                // For passage questions, we need to count them as one question but render all sub-questions
                                                if (q.questionType === 'PSGS' || q.questionType === 'PSGM') {
                                                    const questionNumber = ++questionCounterRef.current;
                                                    return (
                                                        <React.Fragment key={q.questionId}>
                                                            <div className='question-wrapper passage-question'>
                                                                {renderQuestion({
                                                                    ...q,
                                                                    qNo: questionNumber
                                                                }, qIndex, section.questions)}
                                                            </div>
                                                            <div className='sp-clearFix'></div>
                                                        </React.Fragment>
                                                    );
                                                } else {
                                                    // Handle regular questions
                                                    return (
                                                        <React.Fragment key={q.questionId}>
                                                            <div className='question-wrapper'>
                                                                {renderQuestion({
                                                                    ...q,
                                                                    qNo: ++questionCounterRef.current
                                                                }, qIndex, section.questions)}
                                                            </div>
                                                            <div className='sp-clearFix'></div>
                                                        </React.Fragment>
                                                    );
                                                }
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default PaperDownload;